import React from 'react';

/**
 * Assigns a value to either a callback ref or a `MutableRefObject`.
 * Mirrors the behavior of `@mui/utils/setRef`.
 */
export const setRef = <T>(
  ref: React.MutableRefObject<T | null> | ((instance: T | null) => void) | null | undefined,
  value: T | null
): void => {
  if (typeof ref === 'function') {
    ref(value);
    return;
  }
  if (ref !== null && ref !== undefined) {
    ref.current = value;
  }
};
